import { OIDC_CALLBACK_PATH, safeNext } from "@/lib/authMode";

export type CallbackResult = "none" | "done" | "failed";

// Keycloak redirects to <origin>/auth/callback?code&state (spec R10). The SPA
// uses a HashRouter, so this is finished before the router mounts, and the URL
// becomes /#<next> so the router starts on the page the user wanted.
export async function handleCallbackBeforeRouter(d: {
  keycloak: boolean;
  pathname: string;
  complete: () => Promise<string>;
  replace: (url: string) => void;
}): Promise<CallbackResult> {
  if (!d.keycloak || d.pathname !== OIDC_CALLBACK_PATH) return "none";
  try {
    const next = await d.complete();
    d.replace(`/#${safeNext(next)}`);
    return "done";
  } catch {
    d.replace("/");
    return "failed";
  }
}
